import {
    KeyboardState,
    ConnectInputToKeyboardAction,
    DisconnectKeyboardAction,
    ToggleKeyboardDisableValueAction,
    PressedKeyboardButtonAction,
    SetupEnterFunctionAction,
    ChangeKeyboardMaskAction
} from "./type";

export function connectInputToKeyboardHandler(state: KeyboardState, action: ConnectInputToKeyboardAction) {
    if (!state.isDisabled) {
        return state;
    }
    return Object.assign({}, state, {
        pipe: action.payload.pipe,
        value: action.payload.value,
        showKeyboard: true,
        mask: action.payload.mask,
        focusedElementId: action.payload.elementId,
        keyboardType: action.payload.keyboardType
    });
}

export function disconnectKeyboardHandler(state: KeyboardState, action: DisconnectKeyboardAction) {
    return Object.assign({}, state, { pipe: () => {}, value: "", showKeyboard: false, focusedElementId: "" });
}

export function toggleKeyboardDisableValueHandler(state: KeyboardState, action: ToggleKeyboardDisableValueAction) {
    return Object.assign({}, state, {
        pipe: () => {},
        value: "",
        showKeyboard: false,
        focusedElementId: "",
        mask: "",
        isDisabled: !state.isDisabled
    });
}

export function pressedKeyboardButtonHandler(state: KeyboardState, action: PressedKeyboardButtonAction) {
    return Object.assign({}, state, { value: action.payload.value });
}

export function setupEnterFunctionHandler(state: KeyboardState, action: SetupEnterFunctionAction) {
    return Object.assign({}, state, { enterFunction: action.payload.enterFunction });
}

export function changeKeyboardMaskHandler(state: KeyboardState, action: ChangeKeyboardMaskAction) {
    return Object.assign({}, state, { mask: action.payload.mask, value: "" });
}



// WEBPACK FOOTER //
// ./src/store/Keyboard/handlers.ts